import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// 获取浏览器语言
const getBrowserLanguage = () => {
  const lang = (navigator.language || navigator.userLanguage).toLowerCase()
  if (lang.startsWith('zh')) {
    return 'zh'
  } else if (lang.startsWith('en')) {
    return 'en'
  }
  return 'zh'  // 默认中文
}

const messages = {
  zh: {
    language: '语言',
    english: '英语',
    chinese: '中文',
    hero: {
      title: '探寻未至之境',
      keynote:"TripSeek领航前路",
      description: '踏上由 TripSeek 精心雕琢的非凡旅程，感受旅行的全新定义。',
      newFeature: '新功能：产品适合度分析',
      newFeatureText: '不知道如何选择?粘贴产品链接,我们来告诉你！'
    },
    trips: {
      title: '您可以这样来问我',
      list: [
        {name:'[产品推荐] 我想去云南,帮我设计一条5日4晚的行程,并推荐一些产品!', value: '我想去云南,帮我设计一条5日4晚的行程,并推荐一些产品!'},
        {name:'[粘贴携程产品链接,并直接问我] 我们2大1小,这条产品适合我吗?', value: 'https://vacations.ctrip.com/travel/detail/p18508847?city=2,我们2大1小,这条产品适合我吗?'},
        {name:'[本地活动] 最近上海有什么推荐的当地活动吗?', value: '最近上海有什么推荐的当地活动吗?'},
        {name:'[推荐顾问] 我想去瑞士,帮我推荐一位离我最近的5星旅游顾问', value: '我想去瑞士,帮我推荐一位离我最近的5星旅游顾问'}
      ]
    },
    aiBadge: 'AI优化',
    chatbox: {
      title: 'TripSeek',
      placeholder: '输入您的旅行问题...',
      initialMessage: '您好！我是您的AI旅行探索助手。不知道去哪玩？我可以根据您的兴趣和预算，为您定制专属旅行方案。不知道怎么挑产品?没问题,粘贴产品链接,让我们来告诉你是否符合您的要求。',
      responses: [
        '我们的AI可以根据您的兴趣和预算，精准定制个性化的旅行路线，让每一站都充满惊喜。',
        '智能预算优化是我的强项。通过大数据分析，我能帮您在有限预算内获得最佳旅行体验。',
        '您对什么类型的旅行最感兴趣？文化探索、美食之旅、自然景观还是城市冒险？告诉我，我就能为您量身定制。'
      ]
    },
    assistant: {
      title: '熟悉您的AI旅行小助手',
      description: '我们的先进人工智能系统具备持续学习与自适应能力，拥有百万行业大数据，能够为您提供最优化的旅行建议，并推荐最适合您的产品。',
      features: {
        1: '不知道去哪玩? 数百万条玩法库数据,基于您兴趣的个性化推荐行程',
        2: '不知道怎么挑产品? 粘贴产品链接,让我们来告诉你是否符合您的要求',
        3: '在当地? 热点活动的实时更新,更可呼唤真人顾问线上服务'
      }
    },
    footer: {
      copyright: 'TripSeek. All Rights Reserved'
    }
  },
  en: {
    language: 'Language',
    english: 'English',
    chinese: 'Chinese',
    hero: {
      title: 'Explore the Unknown',
      keynote:"Navigated by TripSeek",
      description: 'Embark on an extraordinary journey meticulously crafted by TripSeek and experience the brand-new definition of travel.',
      newFeature: 'New feature: Product Suitability Analysis',
      newFeatureText: 'Not sure how to choose? Paste the product link and we\'ll let you know!'
    },
    trips: {
      title: 'You can ask me questions like this',
      list: [
        {name:'[Product Recommendation] I want to go to Yunnan. Help me plan a 5-day and 4-night itinerary and recommend some products!', value: 'I want to go to Yunnan. Help me plan a 5-day and 4-night itinerary and recommend some products!'},
        {name:'[Paste the Ctrip product link and directly ask me] We are two adults and one child. Is this product suitable for us?', value: 'https://vacations.ctrip.com/travel/detail/p18508847?city=2,We are two adults and one child. Is this product suitable for us?'},
        {name:'[Local Activity] Please recommend some local activities for me.', value: 'Please recommend some local activities for me'},
        {name:'[Consultant Recommendation] I want to go to Switzerland,Please recommend a five-star travel consultant nearest to me.', value: 'I want to go to Switzerland,Please recommend a five-star travel consultant nearest to me.'}
      ]
    },
    aiBadge: 'AI Optimized',
    chatbox: {
      title: 'TripSeek',
      placeholder: 'Enter your travel question...',
      initialMessage: 'Hello! I\'m your AI travel exploration assistant. Not sure where to go? I can customize an exclusive travel plan for you based on your interests and budget. Uncertain about how to choose a product? No problem. Just paste the product link, and let me tell you if it meets your requirements',
      responses: [
        'Our AI can precisely customize personalized travel routes based on your interests and budget, making each stop full of surprises.',
        'Smart budget optimization is my specialty. Through big data analysis, I can help you get the best travel experience within a limited budget.',
        'What type of travel are you most interested in? Cultural exploration, food tours, natural landscapes, or urban adventures? Tell me, and I will tailor a plan just for you.'
      ]
    },
    assistant: {
      title: 'Meet Your AI Trip Assistant',
      description: 'Our advanced artificial intelligence system has the capabilities of continuous learning and self - adaptation. With access to millions of pieces of industry big data, it can provide you with optimized travel advice and recommend the products that best suit you.',
      features: {
        1: 'Not sure where to go? With millions of data entries in our play style library, we\'ll offer you personalized itinerary recommendations based on your interests.',
        2: 'Not sure how to choose a product? Just paste the product link, and let us tell you if it meets your requirements.',
        3: 'Are you at your travel destination? You can get real-time updates on local hot events. Moreover, you can request online services from our human consultants.'
      }
    },
    footer: {
      copyright: 'TripSeek. All Rights Reserved'
    }
  }
}

const i18n = new VueI18n({
  locale: localStorage.getItem('language') || getBrowserLanguage(), // 优先使用localStorage，其次使用浏览器语言
  messages
})

export default i18n
